module.exports = __webpack_public_path__ + "static/img/logo_pancak.d40aa89a.png";